import React, { createContext, useMemo } from 'react'
import { useContext as useReactContext } from 'react'
import { useAuth } from '../auth/AuthContext'

export type ApplicationUser = {
  id: string
  email?: string
  applicationRoleNames: string[]
  expertRoleNames: string[]
}

type ApplicationUserContextValue = { applicationUser: ApplicationUser; isAuthorized: boolean }
const Ctx = createContext<ApplicationUserContextValue | undefined>(undefined)

export const Provider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user, token } = useAuth()
  const appUser: ApplicationUser = useMemo(() => ({
    id: user?.id || '',
    email: user?.email,
    applicationRoleNames: (user?.applicationRoles as string[]) || [],
    expertRoleNames: (user?.expertRoles as string[]) || [],
  }), [user])
  const value: ApplicationUserContextValue = useMemo(() => ({ applicationUser: appUser, isAuthorized: Boolean(token) }), [appUser, token])
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>
}

export function useApplicationUserContext(): ApplicationUserContextValue {
  const v = useReactContext(Ctx)
  if (!v) throw new Error('ApplicationUser context not provided')
  return v
}


